<template>
  <v-flex>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Reporte de Pasajeros por Procedencia</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-chip label class="mr-1" link :color="colorAccent1" @click="_exportarExcel()">
          <span v-bind:style="{ color: 'white' }">
            Exportar a Excel
          </span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col cols="12" md="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaDesde" autocomplete="off"
              label="Búsqueda por fecha desde" placeholder="AAAA-MM-DD"
              @keyup.enter="_getReportePasajerosProcedencia()"
              :error-messages="errorDesde"
              @input="validateFechaDesde"
              hint="Formato: AAAA-MM-DD"
              persistent-hint
              maxlength="10"
              dense></v-text-field>
          </v-col>
          <v-col cols="12" md="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaHasta" autocomplete="off"
              label="Búsqueda por fecha hasta" placeholder="AAAA-MM-DD"
              @keyup.enter="_getReportePasajerosProcedencia()"
              :error-messages="errorHasta"
              @input="validateFechaHasta"
              hint="Formato: AAAA-MM-DD"
              persistent-hint
              maxlength="10"
              dense></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="d-flex align-center">
            <v-chip class="mx-4 mt-md-0 mt-2 px-6" label link :color="colorAccent1" @click="_getReportePasajerosProcedencia()">
              <span v-bind:style="{ color: 'white' }">Buscar</span>
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <template v-if="!loading">
      <v-row class="ma-2" dense>
        <v-col cols="12" sm="6" md="4" lg="3" class="col-totales-desktop">
          <v-card class="pa-4" color="rgb(250, 250, 250)">
            <div class="text-caption grey--text text--darken-1">Total pasajeros</div>
            <div class="text-h4 font-weight-bold">{{ totalesVerificacion.total_pasajeros }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" class="col-totales-desktop">
          <v-card class="pa-4" color="rgb(250, 250, 250)">
            <div class="text-caption grey--text text--darken-1">Pasajeros España</div>
            <div class="text-h4 font-weight-bold">{{ totalesVerificacion.total_pasajeros_espana }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" class="col-totales-desktop">
          <v-card class="pa-4" color="rgb(250, 250, 250)">
            <div class="text-caption grey--text text--darken-1">Pasajeros extranjeros</div>
            <div class="text-h4 font-weight-bold">{{ totalesVerificacion.total_pasajeros_extranjeros }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" class="col-totales-desktop">
          <v-card class="pa-4" color="rgb(250, 250, 250)">
            <div class="text-caption grey--text text--darken-1">Sin nacionalidad</div>
            <div class="text-h4 font-weight-bold">{{ totalesVerificacion.total_pasajeros_sin_nacionalidad }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" class="col-totales-desktop">
          <v-card class="pa-4" color="rgb(250, 250, 250)">
            <div class="text-caption grey--text text--darken-1">España sin provincia</div>
            <div class="text-h4 font-weight-bold">{{ totalesVerificacion.total_pasajeros_espana_sin_provincia }}</div>
          </v-card>
        </v-col>
      </v-row>

      <v-card class="ma-2" color="rgb(250, 250, 250, 1)">
        <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
          <v-toolbar-title :dark="!dark">Pasajeros por País</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-row v-if="porPais.length" class="mt-2" justify="center" dense>
            <v-col cols="12">
              <v-card class="pa-4">
                <h2 class="mb-4 text-center">Distribución de Pasajeros por País</h2>
                <v-row>
                  <v-col cols="12" md="6" class="d-flex justify-center align-center">
                    <canvas ref="pieChartPais" width="400" height="400"></canvas>
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex align-center">
                    <div ref="leyendaContainerPais" style="width: 100%;"></div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-2" justify="start" dense>
            <v-col cols="12">
              <v-data-table locale="es" dense :headers="headersPorPais" hide-default-footer :items="porPais"
                :items-per-page="-1"
                class="mt-2 elevation-1 alternating-rows bordered-table">
                <template v-slot:no-data>
                  No hay datos disponibles
                </template>
                <template v-slot:body.append>
                  <tr class="font-weight-bold" style="background-color: #e3f2fd;">
                    <td class="text-left">TOTALES</td>
                    <td class="text-center">{{ totalPasajerosEnPresupuestosPorPais }}</td>
                    <td class="text-center">{{ totalPasajerosConfirmadosPorPais }}</td>
                    <td class="text-center">{{ totalPasajerosPorPais }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="ma-2" color="rgb(250, 250, 250, 1)">
        <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
          <v-toolbar-title :dark="!dark">Pasajeros de España por Provincia</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-row v-if="porProvincia.length" class="mt-2" justify="center" dense>
            <v-col cols="12">
              <v-card class="pa-4">
                <h2 class="mb-4 text-center">Distribución de Pasajeros de España por Provincia</h2>
                <v-row>
                  <v-col cols="12" md="6" class="d-flex justify-center align-center">
                    <canvas ref="pieChartProvincia" width="400" height="400"></canvas>
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex align-center">
                    <div ref="leyendaContainerProvincia" style="width: 100%;"></div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-2" justify="start" dense>
            <v-col cols="12">
              <v-data-table locale="es" dense :headers="headersPorProvincia" hide-default-footer :items="porProvincia"
                :items-per-page="-1"
                class="mt-2 elevation-1 alternating-rows bordered-table">
                <template v-slot:no-data>
                  No hay datos disponibles
                </template>
                <template v-slot:body.append>
                  <tr class="font-weight-bold" style="background-color: #e3f2fd;">
                    <td class="text-left">TOTALES</td>
                    <td class="text-center">{{ totalPasajerosEnPresupuestosPorProvincia }}</td>
                    <td class="text-center">{{ totalPasajerosConfirmadosPorProvincia }}</td>
                    <td class="text-center">{{ totalPasajerosPorProvincia }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </v-flex>
</template>

<script>
import { mapState, mapActions } from "vuex";
import * as XLSX from "xlsx";

export default {
  data: () => ({
    mostrarbusqueda: true,
    busquedaDesde: "",
    busquedaHasta: "",
    errorDesde: "",
    errorHasta: "",

    headersPorPais: [
      {
        text: "PAÍS",
        align: "left",
        sortable: false,
        value: "pais",
      },
      {
        text: "PASAJEROS PRESUPUESTADOS",
        align: "center",
        sortable: false,
        value: "pasajeros_en_presupuestos",
        width: "260px",
      },
      {
        text: "PASAJEROS CONFIRMADOS",
        align: "center",
        sortable: false,
        value: "pasajeros_confirmados",
        width: "260px",
      },
      {
        text: "TOTAL PASAJEROS",
        align: "center",
        sortable: false,
        value: "total_pasajeros",
        width: "180px",
      },
    ],

    headersPorProvincia: [
      {
        text: "PROVINCIA",
        align: "left",
        sortable: false,
        value: "provincia",
      },
      {
        text: "PASAJEROS PRESUPUESTADOS",
        align: "center",
        sortable: false,
        value: "pasajeros_en_presupuestos",
        width: "260px",
      },
      {
        text: "PASAJEROS CONFIRMADOS",
        align: "center",
        sortable: false,
        value: "pasajeros_confirmados",
        width: "260px",
      },
      {
        text: "TOTAL PASAJEROS",
        align: "center",
        sortable: false,
        value: "total_pasajeros",
        width: "180px",
      },
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",
      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("reportes", ["reportePasajerosProcedencia"]),

    totalesVerificacion() {
      return this.reportePasajerosProcedencia?.totales_verificacion || {
        total_pasajeros: 0,
        total_pasajeros_espana: 0,
        total_pasajeros_extranjeros: 0,
        total_pasajeros_sin_nacionalidad: 0,
        total_pasajeros_espana_sin_provincia: 0,
      };
    },

    porPais() {
      return this.reportePasajerosProcedencia?.data?.por_pais || [];
    },

    porProvincia() {
      return this.reportePasajerosProcedencia?.data?.espana_por_provincia || [];
    },

    totalPasajerosPorPais() {
      return this.porPais.reduce((acc, item) => acc + (parseInt(item.total_pasajeros) || 0), 0);
    },

    totalPasajerosEnPresupuestosPorPais() {
      return this.porPais.reduce((acc, item) => acc + (parseInt(item.pasajeros_en_presupuestos) || 0), 0);
    },

    totalPasajerosConfirmadosPorPais() {
      return this.porPais.reduce((acc, item) => acc + (parseInt(item.pasajeros_confirmados) || 0), 0);
    },

    totalPasajerosPorProvincia() {
      return this.porProvincia.reduce((acc, item) => acc + (parseInt(item.total_pasajeros) || 0), 0);
    },

    totalPasajerosEnPresupuestosPorProvincia() {
      return this.porProvincia.reduce((acc, item) => acc + (parseInt(item.pasajeros_en_presupuestos) || 0), 0);
    },

    totalPasajerosConfirmadosPorProvincia() {
      return this.porProvincia.reduce((acc, item) => acc + (parseInt(item.pasajeros_confirmados) || 0), 0);
    },
  },

  watch: {
    porPais: {
      handler() {
        this.$nextTick(() => {
          this.dibujarGraficaPastelPais();
        });
      },
      deep: true,
    },
    porProvincia: {
      handler() {
        this.$nextTick(() => {
          this.dibujarGraficaPastelProvincia();
        });
      },
      deep: true,
    },
  },

  mounted() {
    this._getReportePasajerosProcedencia();
  },

  methods: {
    ...mapActions("reportes", ["getReportePasajerosProcedencia"]),

    dibujarGraficaPastelPais() {
      this._dibujarGraficaPastel({
        canvasRef: "pieChartPais",
        legendRef: "leyendaContainerPais",
        datos: this.porPais.map((item) => ({
          label: item.pais || "Sin país",
          value: parseInt(item.total_pasajeros) || 0,
          detailLabel: "pasajeros",
        })),
      });
    },

    dibujarGraficaPastelProvincia() {
      this._dibujarGraficaPastel({
        canvasRef: "pieChartProvincia",
        legendRef: "leyendaContainerProvincia",
        datos: this.porProvincia.map((item) => ({
          label: item.provincia || "Sin provincia",
          value: parseInt(item.total_pasajeros) || 0,
          detailLabel: "pasajeros",
        })),
      });
    },

    _dibujarGraficaPastel({ canvasRef, legendRef, datos }) {
      const canvas = this.$refs[canvasRef];
      if (!canvas) {
        return;
      }

      const ctx = canvas.getContext("2d");
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = Math.min(centerX, centerY) - 40;
      const datosConValor = datos.filter((dato) => dato.value > 0);

      if (datosConValor.length === 0) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = "16px Arial";
        ctx.fillStyle = "#666";
        ctx.textAlign = "center";
        ctx.fillText("No hay datos para mostrar", centerX, centerY);
        if (this.$refs[legendRef]) {
          this.$refs[legendRef].innerHTML = "";
        }
        return;
      }

      const total = datosConValor.reduce((sum, dato) => sum + dato.value, 0);
      const colores = [
        "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF",
        "#FF9F40", "#C9CBCF", "#8BC34A", "#FF7043", "#26A69A",
        "#5C6BC0", "#AB47BC", "#EC407A", "#7E57C2", "#42A5F5",
      ];

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let startAngle = -Math.PI / 2;

      datosConValor.forEach((dato, index) => {
        const sliceAngle = (dato.value / total) * 2 * Math.PI;
        const endAngle = startAngle + sliceAngle;

        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fillStyle = colores[index % colores.length];
        ctx.fill();
        ctx.strokeStyle = "#fff";
        ctx.lineWidth = 2;
        ctx.stroke();

        const percentage = ((dato.value / total) * 100).toFixed(1);
        if (percentage > 5) {
          const midAngle = startAngle + sliceAngle / 2;
          const textX = centerX + (radius * 0.7) * Math.cos(midAngle);
          const textY = centerY + (radius * 0.7) * Math.sin(midAngle);

          ctx.fillStyle = "#fff";
          ctx.font = "bold 16px Arial";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(`${percentage}%`, textX, textY);
        }

        startAngle = endAngle;
      });

      if (this.$refs[legendRef]) {
        let leyendaHTML = '<div style="display: flex; flex-direction: column; gap: 12px; padding: 10px; max-height: 400px; overflow-y: auto;">';

        datosConValor.forEach((dato, index) => {
          const percentage = ((dato.value / total) * 100).toFixed(1);
          const color = colores[index % colores.length];

          leyendaHTML += `
            <div style="display: flex; align-items: center; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
              <div style="width: 24px; height: 24px; background-color: ${color}; border: 2px solid #333; margin-right: 12px; flex-shrink: 0; border-radius: 3px;"></div>
              <span style="font-size: 14px; color: #333; line-height: 1.4;">
                <strong>${dato.label}</strong><br>
                <span style="color: #666;">${dato.value} ${dato.detailLabel} (${percentage}%)</span>
              </span>
            </div>
          `;
        });

        leyendaHTML += "</div>";
        this.$refs[legendRef].innerHTML = leyendaHTML;
      }
    },

    _exportarExcel() {
      const wb = XLSX.utils.book_new();
      const filtros = this.reportePasajerosProcedencia?.filtros || {};

      const resumen = [
        {
          "FECHA DESDE": filtros.fecha_desde || "",
          "FECHA HASTA": filtros.fecha_hasta || "",
          "TOTAL PASAJEROS": this.totalesVerificacion.total_pasajeros,
          "TOTAL PASAJEROS ESPAÑA": this.totalesVerificacion.total_pasajeros_espana,
          "TOTAL PASAJEROS EXTRANJEROS": this.totalesVerificacion.total_pasajeros_extranjeros,
          "TOTAL SIN NACIONALIDAD": this.totalesVerificacion.total_pasajeros_sin_nacionalidad,
          "TOTAL ESPAÑA SIN PROVINCIA": this.totalesVerificacion.total_pasajeros_espana_sin_provincia,
        },
      ];
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(resumen), "Resumen");

      const datosPorPais = this.porPais.map((item) => ({
        "PAÍS": item.pais || "",
        "PASAJEROS PRESUPUESTADOS": item.pasajeros_en_presupuestos || 0,
        "PASAJEROS CONFIRMADOS": item.pasajeros_confirmados || 0,
        "TOTAL PASAJEROS": item.total_pasajeros || 0,
      }));
      datosPorPais.push({
        "PAÍS": "TOTALES",
        "PASAJEROS PRESUPUESTADOS": this.totalPasajerosEnPresupuestosPorPais,
        "PASAJEROS CONFIRMADOS": this.totalPasajerosConfirmadosPorPais,
        "TOTAL PASAJEROS": this.totalPasajerosPorPais,
      });
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(datosPorPais), "Por País");

      const datosPorProvincia = this.porProvincia.map((item) => ({
        "PROVINCIA": item.provincia || "",
        "PASAJEROS PRESUPUESTADOS": item.pasajeros_en_presupuestos || 0,
        "PASAJEROS CONFIRMADOS": item.pasajeros_confirmados || 0,
        "TOTAL PASAJEROS": item.total_pasajeros || 0,
      }));
      datosPorProvincia.push({
        "PROVINCIA": "TOTALES",
        "PASAJEROS PRESUPUESTADOS": this.totalPasajerosEnPresupuestosPorProvincia,
        "PASAJEROS CONFIRMADOS": this.totalPasajerosConfirmadosPorProvincia,
        "TOTAL PASAJEROS": this.totalPasajerosPorProvincia,
      });
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(datosPorProvincia), "Por Provincia");

      const fecha = new Date().toISOString().split("T")[0];
      XLSX.writeFile(wb, `Reporte_Pasajeros_Procedencia_${fecha}.xlsx`);
    },

    validateFechaDesde() {
      this.errorDesde = "";
      if (this.busquedaDesde && !this.isValidDateFormat(this.busquedaDesde)) {
        this.errorDesde = "El formato debe ser AAAA-MM-DD (ej: 2025-11-20)";
      }
    },

    validateFechaHasta() {
      this.errorHasta = "";
      if (this.busquedaHasta && !this.isValidDateFormat(this.busquedaHasta)) {
        this.errorHasta = "El formato debe ser AAAA-MM-DD (ej: 2025-11-20)";
      }
    },

    isValidDateFormat(dateString) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

      if (!dateRegex.test(dateString)) {
        return false;
      }

      const date = new Date(dateString);
      const [year, month, day] = dateString.split("-").map(Number);

      return date.getFullYear() === year &&
             date.getMonth() === month - 1 &&
             date.getDate() === day;
    },

    async _getReportePasajerosProcedencia() {
      this.validateFechaDesde();
      this.validateFechaHasta();

      if (this.errorDesde || this.errorHasta) {
        return;
      }

      const params = {};
      if (this.busquedaDesde) {
        params.fecha_desde = this.busquedaDesde;
      }
      if (this.busquedaHasta) {
        params.fecha_hasta = this.busquedaHasta;
      }

      await this.getReportePasajerosProcedencia([this.access_token, params]);
    },
  },
};
</script>

<style scoped>
.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}

.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

@media (min-width: 1264px) {
  .col-totales-desktop {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
